import { CommonKey } from '../../../types/api';
import { Section } from '@app/types/inVenue';
import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';

type SectionsInput = {
    clientId: number;
    rightsholderId: number | undefined;
};

const fetchSections = async ({
    clientId,
    rightsholderId,
}: SectionsInput): Promise<Section[]> => {
    if (!rightsholderId) return [];
    const result: Section[] = await sportsApi
        .url(
            `/clients/${clientId}/crowd-iq/rightsholders/${rightsholderId}/stadium/sections`,
        )
        .get()
        .json();
    return result;
};

const useSections = ({ clientId, rightsholderId }: SectionsInput) =>
    useQuery({
        queryKey: [CommonKey.InVenueSections, clientId, rightsholderId],
        queryFn: (): Promise<Section[]> => fetchSections({ clientId, rightsholderId }),
    });

export default useSections;
